import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Constantly Creating Everything From Scratch',
  paragraphs: ['Every week you spend hours preparing assessments, selecting exercises, organizing rehabilitation progressions, creating patient resources, planning treatments, and completing documentation for patients with completely different needs and goals.']
}, {
  emoji: '⚠️',
  title: 'Unsure What Comes Next',
  paragraphs: ["Your patient is progressing—but you're constantly deciding when to increase the challenge, modify an exercise, adjust the plan, or move toward the next stage of rehabilitation.", 'Without an organized system, even routine clinical planning can take far more time than it should.']
}, {
  emoji: '📚',
  title: 'Clinical Resources Everywhere',
  paragraphs: ["Assessment tools. Exercise libraries. Rehabilitation frameworks. Documentation templates. Patient education resources. Everything exists—but it's scattered across books, websites, PDFs, courses, computers, and countless folders.", "You don't need more scattered information. You need one organized clinical system."]
}, {
  emoji: '😩',
  title: "The Work Doesn't End With Your Last Patient",
  paragraphs: ['Evaluations, treatment planning, exercise selection, progress documentation, reassessments, patient education, follow-ups, and paperwork.', "By the time everything is finished, you've spent hours doing work your patients never even see."]
}];
export function PainSection() {
  return <section className="py-10 px-4 sm:px-6 bg-white border-b border-gray-200" data-id="element-148" data-mp="3imulmdf7okev">
      <h2 className="text-2xl sm:text-3xl font-heading font-black text-center text-brand-navy mb-3 uppercase leading-tight" data-id="element-149" data-mp="3dvmc7hdvsz1p">
        DOES THIS SOUND FAMILIAR?
      </h2>

      <p className="text-sm sm:text-base text-brand-ink/80 font-medium text-center mb-6 leading-snug max-w-2xl mx-auto" data-id="element-150" data-mp="2q476demwbzlp">
        You know how to treat your patients—but everything you have to prepare
        around each patient is consuming your time.
        <span className="text-brand-navy font-bold mt-2 block" data-id="element-151" data-mp="u23pm2cw43sv">
          If you're a physical therapist working in private practice, outpatient
          rehabilitation, sports medicine, orthopedic clinics, hospitals, or
          rehabilitation centers, you've probably experienced at least one of
          these situations:
        </span>
      </p>

      <div className="flex flex-col gap-3 max-w-2xl mx-auto" data-id="element-152" data-mp="6711xxpto6dz">
        {pains.map(pain => <div key={pain.title} className="bg-brand-paper p-4 sm:p-5 rounded-xl border-l-4 border-brand-gold shadow-sm flex gap-4 items-start" data-id="element-153" data-mp="b658shp9xs15">
            <div className="text-2xl sm:text-3xl leading-none shrink-0 mt-0.5" aria-hidden="true" data-id="element-154" data-mp="k6agksydqsfu">
              {pain.emoji}
            </div>
            <div data-id="element-155" data-mp="1vjw6igc2cy2f">
              <h3 className="text-sm sm:text-base font-bold text-brand-navy mb-1.5 uppercase tracking-tight" data-id="element-156" data-mp="1vjctne19szv9">
                {pain.title}
              </h3>
              {pain.paragraphs.map((p, i) => <p key={i} className={`text-sm leading-relaxed ${i === pain.paragraphs.length - 1 && pain.paragraphs.length > 1 ? 'text-brand-navy font-semibold mt-1.5' : 'text-brand-ink/70'}`} data-id="element-157" data-mp="20oge2y9tc1kv" data-mpi={i}>
                  {p}
                </p>)}
            </div>
          </div>)}
      </div>

      <p className="text-center text-sm sm:text-base font-bold text-brand-navy mt-6 max-w-2xl mx-auto leading-snug" data-id="element-158" data-mp="1muywhj0osyxh">
        Your time should be focused on patient care—not rebuilding the same
        clinical resources again and again.
      </p>
    </section>;
}